import { Box, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

import EditIcon from '../../../../shared/assets/icons/edit.svg?react';

import { useSessionClientName } from '../../hooks/useSessionClientName';
import translateClientName from '../../../../utils/TranslatedPossibleClientName';

import { ButtonUi } from '../../../UI/Button/Button';

export const SessionClientCard = (props) => {
  const { openReassignClientModal } = props;
  const { t } = useTranslation();

  const [clientName, setClientName] = useSessionClientName();

  return (
    <Box className='row row-detail align-items-left'>
      <Typography className='label' variant='h6'>
        {t('forms.client_name')}
      </Typography>
      <Typography className='value' variant='h6'>
        {t(`${translateClientName(clientName)}`)}
      </Typography>
      <Box className='actions'>
        <ButtonUi
          isIconBtn
          tooltipTitle={t(`Edit session's client`)}
          tooltipPlacement='top'
          className='primary edit-btn'
          size='small'
          onClickHandler={openReassignClientModal}
        >
          <EditIcon />
        </ButtonUi>
      </Box>
    </Box>
  );
};
